const perf_data = require('../performances/perf-charts-data');
const constants = require('../../shared/constants');
const constantsShared = require('../../shared/constants');

module.exports = function (data, categories) {

  // TODO
  if(!data) {
    data = [];
    $.each(perf_data[0], function(key, value) {
      data[key]=value;
    });
  }

  const options = {
    colors: constants.COLORS.PROFILES,
    chart: {
      type: 'column',
      style: {
        fontSize: '1em'
      }
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: categories || data.name,
      labels: {
        useHTML: true,
        formatter: function () {
          const cat = this.axis.categories,
          v = '<span class="mobile-hide" style="display: block;border-radius: 10px;color: #fff;font-size: 18px;line-height: 23px;width:40px;height: 40px;line-height: 40px;margin-top:8px; background-color: ' + constants.COLORS.PROFILES[cat.indexOf(this.value)] + '">P' + (cat.indexOf(this.value) + 1) + '</span>',
          html = "<span class='mobile-fontsize' style=\"display: block; margin-left: auto; margin-right: auto; text-align: center; font-size: 12px; color: #858B9D; font-weight: 600; font-family: "+ constantsShared.FONT_CHARTS.fontFamily +"; text-align: center; line-height: 16px\">" + this.value + v + '</span>'
          return html
        },
        autoRotation: false
      },
      tickLength: 0,
      lineColor: '#5D6B7C',
    },
    yAxis: {
      min: 0,
      title: {
        text: null
      },
      labels: {
        enabled: false
      },
      gridLineColor: '#F1F2F4',
      gridLineDashStyle: 'dash',
      gridLineWidth: 1.5
    },
    tooltip: {
      headerFormat: '',
      backgroundColor: 'rgba(239,243,247, 0.85)',
      borderWidth: 0,
      borderRadius: 7,
      shadow: false,
      formatter: function () {
        const id = this.point.x,
            name = this.point.options.name,
            perf = this.y,
            vol = this.point.options.vol,
            color = this.point.color
        return "<span style='color: " + color + "; font-weight: 600'>P" + (id + 1) + " : " + name + "</span><br />Perf. <span style='color: " + color + "'>" + perf + "%</span><br />Vol. " + vol + "%"
      },
      style: {
        fontFamily: constantsShared.FONT_CHARTS.fontFamily,
        fontSize: '1em',
        fontWeight: 600,
        zIndex: 10,
        color: '#5C6B7E'
      },
      useHTML: true,
      positioner:function(label_width, label_height, point){
        const x = point.plotX - label_width/2 + this.chart.plotLeft;
        const y = point.plotY - label_height - 30;
        return { x: x, y: y };
      }
    },
    series: [{
      colorByPoint: true,
      data: $.extend(true, [], data)
    }],
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: 'none',
          formatter: function () {
            return '<span style="color:' + this.point.color + '"; font-family: "'+constantsShared.FONT_CHARTS.fontFamily+'; font-size: 18px; font-weight: 600">' + this.y + '%</span>'
          },
          style: {
            fontSize: '1em',
            fontWeight: 600
          }
        },
        groupPadding: 0.04,
        borderWidth: 0,
        pointPadding: 0.15
      }
    }
  }

  const self = {
    chart: '',
    $el: $('#chart-perf'),
    options: options
  }

  self.$el.highcharts(self.options)

  return {
    reload: function(){
      self.$el.highcharts().destroy()
      self.$el.highcharts(self.options)
    }
  }
}
